import { j as e } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as p } from "../../../node_modules/clsx/dist/clsx.m.js";
import { useState as M, useRef as H } from "react";
import { useFloating as L, useInteractions as z, useHover as U, safePolygon as $, useClick as q, useDismiss as G, FloatingFocusManager as J, FloatingPortal as K, FloatingArrow as Q } from "../../../node_modules/@floating-ui/react/dist/floating-ui.react.js";
import S from "../../../node_modules/lodash/isEmpty.js";
import a from "./Tooltip.module.scss.js";
import { Typography as T } from "../Typography/Typography.js";
import V from "../CompactButton/CompactButton.js";
import X from "../StepperDot/StepperDot.js";
import Y from "../LinkButton/LinkButton.js";
import D from "../Button/Button.js";
import { offset as Z, arrow as _, flip as tt, shift as et } from "../../../node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.js";
import { autoUpdate as st } from "../../../node_modules/@floating-ui/dom/dist/floating-ui.dom.js";
const E = ({
  title: s,
  description: i,
  hideArrow: l,
  trigger: n,
  triggerWidth: o,
  children: c,
  footer: t,
  maxWidth: b,
  minWidth: k,
  withClose: d,
  floatingFocusManagerProps: F,
  testId: m,
  getReferenceProps: B,
  getFloatingProps: P,
  refs: x,
  context: g,
  open: N,
  floatingStyles: h,
  handleOnClose: j,
  tooltipArrowRef: R,
  disabled: A,
  behavior: u,
  disabledFocus: v,
  zIndex: f = 1006
}) => {
  const y = document.body.getAttribute("dir") === "rtl";
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      "div",
      {
        ...B(),
        ref: x.setReference,
        className: a.tooltip,
        "data-testid": m,
        style: { width: o },
        children: n
      }
    ),
    !A && (s || i || c || t) && /* @__PURE__ */ e.jsx(
      J,
      {
        modal: !1,
        context: g,
        ...F,
        disabled: v,
        children: /* @__PURE__ */ e.jsx(K, { children: N && /* @__PURE__ */ e.jsxs(
          "div",
          {
            id: "tooltip-container",
            className: p(
              a.popoverContainer,
              u === "tooltip" && a.toolTipContainer
            ),
            style: { ...h, minWidth: k, maxWidth: b, zIndex: f },
            ref: x.setFloating,
            ...P(),
            children: [
              (s || d || i) && /* @__PURE__ */ e.jsxs("div", { children: [
                /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
                  s && /* @__PURE__ */ e.jsx(
                    T,
                    {
                      text: s,
                      variant: "body-new/semibold",
                      textColor: "color/fg/default",
                      className: p({ "pe-250": d })
                    }
                  ),
                  d && /* @__PURE__ */ e.jsx(
                    "div",
                    {
                      className: p("absolute -top-100", {
                        "-right-100": !y,
                        "-left-100": y
                      }),
                      children: /* @__PURE__ */ e.jsx(
                        V,
                        {
                          variant: "ghost",
                          onClick: j,
                          testId: `${m}CompactButton`,
                          size: "small"
                        }
                      )
                    }
                  )
                ] }),
                i && /* @__PURE__ */ e.jsx(
                  T,
                  {
                    text: i,
                    variant: "subtitle-2",
                    textColor: "color/fg/light"
                  }
                )
              ] }),
              c && /* @__PURE__ */ e.jsx(e.Fragment, { children: c }),
              ((t == null ? void 0 : t.primaryButton) || (t == null ? void 0 : t.secondaryButton) || (t == null ? void 0 : t.link) || (t == null ? void 0 : t.stepper)) && /* @__PURE__ */ e.jsxs("div", { className: a.tooltipFooter, children: [
                !t.fullWidth && /* @__PURE__ */ e.jsxs("div", { className: a.footer3rdActions, children: [
                  !S(t.stepper) && /* @__PURE__ */ e.jsx(
                    X,
                    {
                      active: t.stepper.active,
                      count: t.stepper.count ?? 0,
                      onChange: t.stepper.onChange,
                      size: "medium"
                    }
                  ),
                  !S(t.link) && /* @__PURE__ */ e.jsx(
                    Y,
                    {
                      label: t.link.label,
                      variant: "neutral",
                      size: "small",
                      trailingIcon: t.link.trailingIcon,
                      href: t.link.href,
                      onClick: t.link.onClick
                    }
                  )
                ] }),
                /* @__PURE__ */ e.jsxs(
                  "div",
                  {
                    className: p(
                      a.mainFooterActions,
                      t.fullWidth && a.footerFullWidth
                    ),
                    children: [
                      t.secondaryButton && /* @__PURE__ */ e.jsx(
                        D,
                        {
                          ...t.secondaryButton,
                          variant: "ghost",
                          color: "neutral",
                          size: "small",
                          onClick: (w) => {
                            var r, C;
                            (C = (r = t.secondaryButton) == null ? void 0 : r.onClick) == null || C.call(r, w), j();
                          }
                        }
                      ),
                      t.primaryButton && /* @__PURE__ */ e.jsx(
                        D,
                        {
                          ...t.primaryButton,
                          variant: "filled",
                          color: "primary",
                          size: "small"
                        }
                      )
                    ]
                  }
                )
              ] }),
              !l && /* @__PURE__ */ e.jsx(
                Q,
                {
                  ref: R,
                  context: g,
                  className: p("fill-color-bg-base-default", {
                    "fill-color-bg-neutral-boldest-default": u === "tooltip"
                  })
                }
              )
            ]
          }
        ) })
      }
    )
  ] });
}, it = (s) => {
  const i = U(s.context, {
    handleClose: $()
  }), { getReferenceProps: l, getFloatingProps: n } = z([i]);
  return /* @__PURE__ */ e.jsx(
    E,
    {
      ...s,
      getFloatingProps: n,
      getReferenceProps: l,
      children: s.children
    }
  );
}, lt = (s) => {
  const i = q(s.context), l = G(s.context, {
    outsidePress: () => (s.disableCloseOut || s.handleOnClose(), !s.disableCloseOut)
  }), { getReferenceProps: n, getFloatingProps: o } = z([i, l]);
  return /* @__PURE__ */ e.jsx(
    E,
    {
      ...s,
      getFloatingProps: o,
      getReferenceProps: n,
      children: s.children
    }
  );
}, vt = ({
  title: s,
  description: i,
  placement: l = "bottom",
  hideArrow: n,
  behavior: o = "tooltip",
  trigger: c,
  children: t,
  footer: b,
  withClose: k = !1,
  maxWidth: d = "360px",
  minWidth: F = "auto",
  onClose: m,
  floatingFocusManagerProps: B,
  testId: P,
  disabled: x,
  triggerWidth: g,
  disableCloseOut: N,
  open: h,
  disabledFocus: j,
  zIndex: R
}) => {
  const [A, u] = M(!1), v = h ?? A, f = H(null), { refs: y, floatingStyles: w, context: r } = L({
    open: v,
    onOpenChange: u,
    placement: l,
    middleware: [
      Z(l.includes("left") || l.includes("right") ? 10 : 5),
      _({
        element: f
      }),
      tt({
        fallbackAxisSideDirection: "end"
      }),
      et()
    ],
    whileElementsMounted: st
  }), C = () => {
    h === void 0 && u(!1), m && m();
  }, { getReferenceProps: I, getFloatingProps: W } = z([]), O = {
    title: s,
    description: i,
    placement: l,
    hideArrow: n,
    trigger: c,
    children: t,
    footer: b,
    withClose: k,
    open: v,
    maxWidth: d,
    minWidth: F,
    handleOnClose: C,
    context: r,
    floatingStyles: w,
    tooltipArrowRef: f,
    floatingFocusManagerProps: B,
    testId: P,
    refs: y,
    getReferenceProps: I,
    getFloatingProps: W,
    disabled: x,
    triggerWidth: g,
    behavior: o,
    disabledFocus: j,
    zIndex: R
  };
  return o === "popover" ? /* @__PURE__ */ e.jsx(
    lt,
    {
      ...O,
      disableCloseOut: N
    }
  ) : /* @__PURE__ */ e.jsx(it, { ...O });
};
export {
  vt as default
};
//# sourceMappingURL=Tooltip.js.map
